<template>
    <rkm-form>
        <rkm-row>
            <rkm-col>
                <rkm-form-textarea
                    label="Observações"
                    max-rows="5"
                    readonly
                    v-model="model.observacoes"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
export default {
    props: {
        model: { type: Object, required: true },
    },
}
</script>